export default __webpack_public_path__ + "static/media/linkendin.077ef4b2.svg";